module.exports = __webpack_public_path__ + "f1a7ba3818ac1e166ee533d2540cafef.svg";